const state = {
  loading: false,
  error: {},
  lineName:'',
  data: [],
};

const getters = {
  getLineName(state) {
    return state.lineName;
  },
};

const actions = {
  setLineTableName(context, data) {
    context.commit("SET_LINE_NAME", data);
  },
};

const mutations = {
  SET_LINE_NAME(state, data) {
    state.lineName = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
